import { render, staticRenderFns } from "./orderRefund.vue?vue&type=template&id=e837cb82&scoped=true&"
import script from "./orderRefund.vue?vue&type=script&lang=js&"
export * from "./orderRefund.vue?vue&type=script&lang=js&"
import style0 from "./orderRefund.vue?vue&type=style&index=0&id=e837cb82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e837cb82",
  null
  
)

export default component.exports